var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_2406)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M4 8.24978L11.51 9.24978L4.01 6.02979L4 8.24978ZM4.01 17.9698L11.51 14.7498L4 15.7498L4.01 17.9698Z",
    fill: "#0F8F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.01 3L2 10L17 12L2 14L2.01 21L23 12L2.01 3ZM4 8.25V6.03L11.51 9.25L4 8.25ZM4.01 17.97V15.75L11.52 14.75L4.01 17.97Z",
    fill: "#0F8F6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_2406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChat);
export default __webpack_public_path__ + "static/media/sendChat.61aabd91fba6b0bba42225019bd40016.svg";
export { ForwardRef as ReactComponent };